import { render, staticRenderFns } from "./ConclusionPage.vue?vue&type=template&id=1a230927&scoped=true"
import script from "./ConclusionPage.vue?vue&type=script&lang=js"
export * from "./ConclusionPage.vue?vue&type=script&lang=js"
import style0 from "./ConclusionPage.vue?vue&type=style&index=0&id=1a230927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a230927",
  null
  
)

export default component.exports